import type { HelpFile } from '../../types/help'
import { ColorPickerTestIds } from '../../../testids/ColorPickerTestIds'

export const colorPickerHelp: HelpFile = {
  docPage: '/docs/admin/branding',
  texts: {
    [ColorPickerTestIds.btnColorPicker]:
      'Choose a hex color for branding accents — links, buttons, and badges.',
  },
}
